import http from "../../http-common";

class EventRightSideLearningService {
    getEventRightSideLearningService(eventPath: string) {
        return http.get(`/right-side-section/events/learning/${eventPath}`);
    }
}

export default new EventRightSideLearningService();
